import React from "react";
import { connect } from "react-redux";
import "react-notifications/lib/notifications.css";
import "./home.style.css";
import { selectSigninStatus } from "../../store/auth/auth.selectors";
import { bindActionCreators } from "redux";

export class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: 1,
        };
    }

    componentDidMount() {
        if (this.props.signinStatus.employee === null || this.props.signinStatus.employee === undefined) {
            this.props.history.replace("/");
        }
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="container">
                <div className="homeWrapper">
                    <p>You are now logged in to the T.V.</p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        signinStatus: selectSigninStatus(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
